<template>
  <div>
    <p class="show_chart">
      <span>
        Total Effective Collateral Amount:
        {{ $utils.formatAmount(totalCollateralAmount) }}
      </span>
      <span>Currency: USD</span>
    </p>
    <table-view
      ref="tableList"
      tableCardTitle="Collateral List"
      :right-btn-options="{
        text: 'Add',
        isHavePermission: $storage.getItem('btn')['Collateral-Add'],
      }"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :row-class-name="tableRowClassName"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
    >
      <!-- files -->
      <template v-slot:files="{ tableRow }">
        <el-popover
          placement="top"
          trigger="click"
          v-if="tableRow.row.files && tableRow.row.files.length"
        >
          <div
            style="text-align: center"
            v-for="item in tableRow.row.files"
            :key="item.id"
          >
            <a href="javascript:void (0)" @click="handleDownload(item.id)">
              {{ item.name }}
            </a>
          </div>
          <el-button type="text" slot="reference">Check</el-button>
        </el-popover>
        <span v-else></span>
      </template>
      <!-- lastModified -->
      <template v-slot:lastModified="{ tableRow }">
        {{ tableRow.row.lastModified || tableRow.row.createTime }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          v-if="$storage.getItem('btn')['Collateral-View']"
          href="javascript:void(0)"
          class="icon-view1"
          style="margin-right: 20px; color: #3a3f63; font-size: 18px"
          @click="handleView(tableRow.row)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            v-if="$storage.getItem('btn')['Collateral-Delete']"
            href="javascript:void (0);"
            class="icon-trash1"
            slot="reference"
            style="color: #3a3f63"
          />
        </el-popconfirm>
      </template>
      <template v-slot:amount="{ tableRow }">
        {{ tableRow.row.amount | formatAmount }}
      </template>
      <template v-slot:localAmount="{ tableRow }">
        {{ tableRow.row.localAmount | formatAmount }}
      </template>
    </table-view>
  </div>
</template>

<script>
import { getTableData, deleteCol, download } from './api'

export default {
  data() {
    const isNotEmpty = arr => Array.isArray(arr) && arr.length > 0
    const tableModel = [
      // {
      //   width: 150,
      //   label: 'ID',
      //   prop: 'id',
      // },
      {
        width: 160,
        label: 'Collateral Category',
        prop: 'collateralCategoryStr',
      },
      {
        width: 160,
        label: 'Collateral Type',
        prop: 'collateralTypeStr',
      },
      {
        width: 140,
        label: 'Effective Date',
        prop: 'effectiveDate',
      },
      {
        width: 150,
        label: 'Expiration Date',
        prop: 'expirationDate',
      },
      {
        width: 120,
        label: 'Local Currency',
        prop: 'localCurrency',
      },
      {
        width: 200,
        label: 'Local Amount',
        slotName: 'localAmount',
      },
      {
        width: 200,
        label: 'Amount $',
        slotName: 'amount',
      },

      {
        width: 130,
        label: 'Attachments',
        slotName: 'files',
      },
      {
        width: 140,
        label: 'Modified By',
        prop: 'operator',
      },
      {
        width: 140,
        label: 'Last Modified',
        slotName: 'lastModified',
      },
      {
        width: 120,
        label: 'Action',
        slotName: 'action',
        fixed: 'left',
      },
    ]
    return {
      tableModel,
      tableData: [],
      pages: {},
      isNotEmpty,
      totalCollateralAmount: 0,
      customerId: this.$route.params.customerId,
      form: {},
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    async handleDownload(id) {
      try {
        await download(id)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    tableRowClassName({ row }) {
      if (row.status) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        this.totalCollateralAmount = 0
        params = {
          companyId: this.customerId,
          ...params,
        }
        const { data, page } = await getTableData(params)
        this.tableData = data
        if (data.length) {
          this.totalCollateralAmount = data[0].totalAmount
        }
        this.pages = page
      } catch (err) {
        console.log(err)
      }
    },
    async handleRemoveItem(id) {
      try {
        const _params = {
          id,
        }
        await deleteCol(_params)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.log(err)
      }
    },
    handleTitleActionBtn() {
      this.$router.push({
        path: `/customer-management/${this.customerId}/info/collateralAdd-detail`,
      })
    },
    handleView(row) {
      this.$router.push({
        path: `/customer-management/${this.customerId}/info/collateral-detail?id=${row.id}`,
      })
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
  },
}
</script>
<style scoped lang="scss">
.show_chart {
  display: flex;
  position: relative;
  top: 75px;
  left: 25px;
  font-size: 14px;
  span {
    margin-right: 100px;
  }
}
</style>
